import "./Features.scss";
import FeaturesList from "@/components/POI/FeaturesList/FeaturesList.vue";
import POIStep from "@/components/POI/POIStep/POIStep.vue";

export default {
  name: "Features",
  props: ["editedItem", "step", "position", "isOwnedBySubPrincipal"],
  components: { FeaturesList, POIStep },
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
